import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Formik } from 'formik'

import Api from 'services/Api'
import BaseModal from 'components/Modals/BaseModal'
import { closeModal } from 'store/actions/modals'
import { Button, Textarea, Checkbox, Form } from 'components/Forms'
import { Loading } from 'components/UI'
import { EventSummaryList } from 'components/Schedule'
import { Alert, Card } from 'ui'

import { t } from 'translations'

const ScheduleRestoreModal = ({ ids }) => {
  const dispatch = useDispatch()
  const [events, setEvents] = useState()
  const [errorLoading, setErrorLoading] = useState(false)

  useEffect(() => {
    const fetchOldEvent = async () => {
      const { result, success } = await Api.post('schedule/schedule/query', { shiftIds: ids, showCancelledShift: true })
      if (!success || !result.length) return setErrorLoading(true)
      setEvents(result)
    }
    fetchOldEvent()
  }, [ids])

  const onSubmit = async ({ sendConfirmationEmails, reason, restorationComment }) => {
    await Api.put('schedule/restore', { eventIds: events.map(({ _id }) => _id), sendConfirmationEmails, reason, restorationComment })
    dispatch(closeModal())
  }

  if (!events && !errorLoading) return <Loading />

  return (
    <BaseModal hideButtons title="manager.schedule.RESTORE_MODAL">
      {errorLoading ? (
        <>
          <Alert variant="warning" className="mt-2">
            {t('manager.schedule.RESTORE_MODAL.ERROR_LOADING')}
          </Alert>
          <Button text="actions.CLOSE" className="btn btn-outline-secondary mt-2" onClick={() => dispatch(closeModal())} />
        </>
      ) : (
        <Formik
          enableReinitialize={true}
          initialValues={{ sendConfirmationEmails: true, reason: '', restorationComment: '' }}
          onSubmit={values => onSubmit(values)}
        >
          {({ values, isSubmitting }) => {
            return (
              <Form className="mt-2">
                <Alert variant="warning" className="mt-2">
                  {t('manager.schedule.RESTORE_MODAL.DESCRIPTION')}
                </Alert>
                <EventSummaryList events={events} />
                <Card className="bg-light mt-2">
                  <Card.Body>
                    {/* Whether or not to send a restoration email */}
                    <Checkbox module="manager.schedule.RESTORE_MODAL" name="sendConfirmationEmails" />
                    {/* Comment to send to the employee */}
                    {values.sendConfirmationEmails ? <Textarea module="manager.schedule.RESTORE_MODAL" name="restorationComment" autoComplete="false" /> : null}
                  </Card.Body>
                </Card>
                <Card className="bg-light mt-2">
                  <Card.Body>
                    {/* Comment to add in the shift edit history */}
                    <Textarea module="manager.schedule.RESTORE_MODAL" name="reason" autoComplete="false" />
                  </Card.Body>
                </Card>
                <div className="mt-2">
                  <Button className="btn btn-primary mr-2" type="submit" isSubmitting={isSubmitting} text="SUBMIT" />
                  <Button className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())}>
                    {t(`actions.CLOSE`)}
                  </Button>
                </div>
              </Form>
            )
          }}
        </Formik>
      )}
    </BaseModal>
  )
}

export default ScheduleRestoreModal
